import { render } from "./AstOrganisationszuordnungen.pug?vue&type=template&id=4e04391a&lang=pug"
import script from "./AstOrganisationszuordnungen.js?vue&type=script&lang=js"
export * from "./AstOrganisationszuordnungen.js?vue&type=script&lang=js"

import "./AstOrganisationszuordnungen.css?vue&type=style&index=0&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__